export var OperationsHiveEngine;
(function (OperationsHiveEngine) {
    OperationsHiveEngine["COMMENT_CURATION_REWARD"] = "comments_curationReward";
    OperationsHiveEngine["COMMENT_AUTHOR_REWARD"] = "comments_authorReward";
    OperationsHiveEngine["MINING_LOTTERY"] = "mining_lottery";
    OperationsHiveEngine["TOKENS_TRANSFER"] = "tokens_transfer";
    OperationsHiveEngine["TOKENS_DELEGATE"] = "tokens_delegate";
    OperationsHiveEngine["TOKEN_UNDELEGATE_START"] = "tokens_undelegateStart";
    OperationsHiveEngine["TOKEN_UNDELEGATE_DONE"] = "tokens_undelegateDone";
    OperationsHiveEngine["TOKEN_STAKE"] = "tokens_stake";
    OperationsHiveEngine["TOKEN_UNSTAKE_START"] = "tokens_unstakeStart";
    OperationsHiveEngine["TOKEN_UNSTAKE_DONE"] = "tokens_unstakeDone";
    OperationsHiveEngine["TOKEN_ISSUE"] = "tokens_issue";
    OperationsHiveEngine["HIVE_PEGGED_BUY"] = "hivepegged_buy";
})(OperationsHiveEngine || (OperationsHiveEngine = {}));
export const CURATIONS_REWARDS_TYPES = [
    OperationsHiveEngine.COMMENT_AUTHOR_REWARD,
    OperationsHiveEngine.COMMENT_CURATION_REWARD,
];
